var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden lg:block"},[_c('full-width-container',{staticClass:"bg-r-gray-ultralight"},[_c('content-container',{staticClass:"px-3 lg:px-12",attrs:{"default-padding":false}},[_c('title-bar',{attrs:{"back-route":{ name: _vm.backRouteName }}},[_vm._v("\n                "+_vm._s(_vm.property.name)+"\n            ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }